import React, { Component } from "react"
import { connect } from "react-redux"
import _ from "lodash"
import * as utils from "../../../utils"
import LabeledValue from "../../../components/LabeledValue"
import FileUpload from "../../../components/FileUpload"
import FileList from "../../../components/FormikComponents/FilePicker/FileList"

class SingleFileUpload extends Component {
  props: {
    label: string,
    uploadCommand: string,
    downloadCommand: string,
    args: Object,
    file: {
      id: number,
      name: string
    },
  }

  showFileUpload () {
    const { uploadCommand, args } = this.props
    return (
      <FileUpload
        command={uploadCommand}
        args={args}
      />
    )
  }

  showFilelist () {
    const { downloadCommand, file, auth, args } = this.props
    return (
      <FileList
        files={[ file ]}
        onFileClick={async file => {
          await utils.downloadFile( auth.token, downloadCommand, args, file.name )
        }}
      />
    )
  }


  render () {
    const { label, file } = this.props
    return (
      <LabeledValue label={label} big>
        {file
          ? this.showFilelist()
          : this.showFileUpload()
        }
      </LabeledValue>
    )
  }
}

export default connect( store => _.pick( store, [ "auth" ] ) )( SingleFileUpload )



// WEBPACK FOOTER //
// ./src/views/LotView/SingleFileUpload/index.jsx